import { EnvironmentConfig, validateEnvironmentConfig } from './environment-config';

export const environment = validateEnvironmentConfig({
  production: false,
  agent: {
    url: 'https://bedrock-agentcore.us-east-1.amazonaws.com/runtimes/arn%3Aaws%3Abedrock-agentcore%3Aus-east-1%3A985796086892%3Aruntime%2Finnovation_workflow_agent-vWqfxlCCcS/invocations?qualifier=DEFAULT'
  },
  uploadsApi: {
    'url': 'https://zmgvaem0y0-vpce-010d441c90f75ff82.execute-api.us-east-1.amazonaws.com/api/uploads',
    'x-api-key': 'rRduDWHeWx4pdP6gnJuso96Qhc6jzVyF3zRRPhIc'
  },
  api: {
    'baseUrl': 'https://qpcjmaqc8b-vpce-010d441c90f75ff82.execute-api.us-east-1.amazonaws.com/api/v1',
    'x-api-key': '1RfPJu23MOaRAt5kruYqF8X3Vk9jWPKozTG8Sru7'
  },
  // oidc: {
  //   clientId: 'OPUEkHHpESPVgEZM2UeVvggtTf64AzBJ',
  //   authority:
  //     'https://api.identity-test.nwie.net/information-risk-management/enterprise-user-auth/v3/employee',
  // },
  oidc: {
    clientId: 'RRAxY8l5hNYMTrTGg79qJw51f7U3Wsp4',
    authority: 'https://api.identity.nationwide.com/information-risk-management/enterprise-user-auth/v3/employee'
  }
} as EnvironmentConfig);
